import { newToolFilterOAuthMcp } from "../oauth.ts";

export const atlassianMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.atlassian.com/apple-touch-icon.png",
  url: "https://mcp.atlassian.com/v2/mcp",
  label: "Atlassian",
});
